const androidProfile = 'talpa_chromecast_mp4_ovp_android';
const iosProfile = 'talpa_chromecast_mp4_ovp_ios';

const appPlayerChannel = 'kijk2 app';

export default function getAppConfiguration(adTagUrl: string = '', senderUserAgent: string = ''): null | string {
  if (!adTagUrl) {
    const platform = senderUserAgent.includes('Android')
      ? 'Android'
      : senderUserAgent.includes('iPhone') || senderUserAgent.includes('iPad')
        ? 'iOS'
        : 'unknown';

    return `${appPlayerChannel} ${platform}`;
  }

  if (adTagUrl.includes(androidProfile)) {
    return `${appPlayerChannel} Android`;
  }

  if (adTagUrl.includes(iosProfile)) {
    return `${appPlayerChannel} iOS`;
  }

  return null;
}
